// 音频总时长，默认为10s
export const AUDIO_DURATION = 10;

// 颜色梯度
export const SEGMENTS_COLOR_LADDER = [
  '#6F51E3',
  '#1B9A63',
  '#4453C7',
  '#DD7C79',
  '#A7917A',
  '#8B9DAE',
  '#B8ACCA',
  '#5FBDE6',
  '#17B5A0',
  '#7079EA',
  '#A19D83',
  '#3C5C85',
] as const;
